import { render, staticRenderFns } from "./UpdateCost.vue?vue&type=template&id=610f6ee4&scoped=true"
import script from "./UpdateCost.vue?vue&type=script&lang=js"
export * from "./UpdateCost.vue?vue&type=script&lang=js"
import style0 from "./UpdateCost.vue?vue&type=style&index=0&id=610f6ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f6ee4",
  null
  
)

export default component.exports